export const addressInfoHandled = (address, infos = ["street", "number", "complement", "district"]) => {
    let finalAddress = "";

    if (infos?.length && address) {
        infos.forEach((info) => {
            if (!!address[info]) {
                if (infos.indexOf(info) === 0) {
                    finalAddress += address[info];
                } else {
                    finalAddress += `, ${address[info]}`;
                }
            }
        })
    }

    return finalAddress;
};